var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1784",
    "data-name": "Group 1784",
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.932,
    height: 82,
    viewBox: "0 0 116.932 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1678",
    "data-name": "Group 1678",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1676",
    "data-name": "Group 1676"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147802",
    "data-name": "Rectangle 147802",
    width: 15.252,
    height: 82,
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147803",
    "data-name": "Rectangle 147803",
    width: 15.252,
    height: 41,
    transform: "translate(20.336 41)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147804",
    "data-name": "Rectangle 147804",
    width: 15.252,
    height: 61.5,
    transform: "translate(40.672 20.5)",
    fill: "#575757"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1677",
    "data-name": "Group 1677",
    transform: "translate(61.008)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147802-2",
    "data-name": "Rectangle 147802",
    width: 15.252,
    height: 82,
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147803-2",
    "data-name": "Rectangle 147803",
    width: 15.252,
    height: 41,
    transform: "translate(20.336 41)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147804-2",
    "data-name": "Rectangle 147804",
    width: 15.252,
    height: 61.5,
    transform: "translate(40.672 20.5)",
    fill: "#575757"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/barChart.c79b1979896610b5a2fca74da0cf679f.svg";
export { ForwardRef as ReactComponent };